import { render, staticRenderFns } from "./chat-element-text.vue?vue&type=template&id=c960f372&scoped=true"
import script from "./chat-element-text.vue?vue&type=script&lang=js"
export * from "./chat-element-text.vue?vue&type=script&lang=js"
import style0 from "./chat-element-text.vue?vue&type=style&index=0&id=c960f372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c960f372",
  null
  
)

export default component.exports